import { useCallback, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { downloadCmpAsPdf } from '../../helpers/downloadBlob';

/**
 * Descarga del presupuesto en PDF desde el carrito (solo comerciales suplantando).
 * La plantilla se pinta oculta bajo `quoteRef` y jsPDF la convierte, igual que
 * el resumen del pedido del historial.
 */
export const useDownloadQuote = () => {
  const quoteRef = useRef(null);
  const [downloading, setDownloading] = useState(false);

  const downloadQuote = useCallback(async (numCliente) => {
    if (!quoteRef.current || downloading) return;
    setDownloading(true);
    try {
      const stamp = new Date().toISOString().slice(0, 10).replace(/-/g, '');
      await downloadCmpAsPdf(quoteRef, `presupuesto-${numCliente ?? 'cliente'}-${stamp}`);
    } catch (error) {
      console.error(error);
      toast.error('No se ha podido generar el presupuesto');
    } finally {
      setDownloading(false);
    }
  }, [downloading]);

  return { quoteRef, downloadQuote, downloading };
};
